import http from "../../helpers/http";
import * as helpers from "../../helpers/helpers";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../utils/siteSettings";
import Text from "../../components/common/Text";

import {
  FETCH_CIRCLE_POST,
  FETCH_CIRCLE_POST_SUCCESS,
  FETCH_CIRCLE_POST_FAILED,
  FETCH_CIRCLE_POST_SEARCH,
  FETCH_CIRCLE_POST_SEARCH_SUCCESS,
  FETCH_CIRCLE_POST_SEARCH_FAILED
} from "./actionTypes";

export const fetchCirclePosts = (formData) => (dispatch) => {
  dispatch({
    type: FETCH_CIRCLE_POST,
    payload: null
  });
  http
    .post("circles", helpers.doObjToFormData(formData))
    .then(({ data }) => {
      dispatch({
        type: FETCH_CIRCLE_POST_SUCCESS,
        payload: data
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_CIRCLE_POST_FAILED,
        payload: error
      });
    });
};

export const searchCircleData = (post) => (dispatch) => {
  dispatch({
    type: FETCH_CIRCLE_POST_SEARCH,
    payload: null
  });
  http
    .post("search-circle-data", helpers.doObjToFormData(post))
    .then(({ data }) => {
      // console.log(data)
      dispatch({
        type: FETCH_CIRCLE_POST_SEARCH_SUCCESS,
        payload: data
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_CIRCLE_POST_SEARCH_FAILED,
        payload: error
      });
    });
};
